


















































































































































































































import {
  ComponentInternalInstance,
  getCurrentInstance,
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { CheckCircleFilledIcon, CloseCircleFilledIcon, FileCopyIcon } from 'tdesign-icons-vue';
import _ from 'lodash';
import RemoveConfigConfirm from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/RemoveConfigConfirm.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import { formatError } from '@/renderer/scripts/utils/errorCode/index';
import { copyText2Clipboard } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { httpUrl } from '@/renderer/scripts/http';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

type IDaasConfigParams = SMH.IDaasConfigParams & {
  [key: string]: string | boolean | number | undefined;
};

export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    initData: {
      required: false,
      type: Object,
      default: {
        tenantName: '',
        clientId: '',
        clientSecret: '',
        wellKnown: '',
        oauthUrl: '',
        callbackUrls: [],
      },
    },
    bindOrg: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  components: {
    CheckCircleFilledIcon,
    CloseCircleFilledIcon,
    FileCopyIcon,
    RemoveConfigConfirm,
  },
  filters: {
    ConfigFormValidateFormatter(code: string) {
      const format: Record<string, string> = {
        success: i18n_t('测试通过，点击完成进行登录验证'),
        error: i18n_t('配置失败'),
        none: i18n_t('待测试'),
      };
      return format[code];
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const showModifyPage = ref(false);
    const currentStep = ref(0);
    const ssoConfig = reactive<any>({
      tenantName: '',
      clientId: '',
      clientSecret: '',
      wellKnown: '',
      oauthUrl: '',
      callbackUrls: [],
    });
    const configFormTips = reactive({
      tenantName: '',
      clientId: '',
      clientSecret: '',
      wellKnown: '',
      validate: {
        code: 'none',
        message: i18n_t('未关联'),
      },
    });
    const disableNextBtn = computed(() => configFormTips.tenantName !== '');
    const showTenantText = ref(false);
    const methods = {
      init() {
        configFormTips.tenantName = '';
        configFormTips.clientId = '';
        configFormTips.clientSecret = '';
        configFormTips.wellKnown = '';
        configFormTips.validate = {
          code: 'none',
          message: i18n_t('未关联'),
        };
        if (
          !props.initData.tenantName ||
          !props.initData.clientId ||
          !props.initData.clientSecret ||
          !props.initData.wellKnown
        ) {
          showModifyPage.value = true;
        } else {
          showModifyPage.value = false;
        }
        Object.assign(ssoConfig, props.initData);
        showTenantText.value = !!props.initData.tenantName && props.bindOrg;
      },
      modifyAssociation() {
        showModifyPage.value = true;
      },
      validateConfigForm(type: string) {
        switch (type) {
          case 'tenantName':
            configFormTips.tenantName = ssoConfig.tenantName === '' ? i18n_t('不能为空') : '';
            break;
          case 'clientId':
            configFormTips.clientId = ssoConfig.clientId === '' ? i18n_t('不能为空') : '';
            break;
          case 'clientSecret':
            configFormTips.clientSecret = ssoConfig.clientSecret === '' ? i18n_t('不能为空') : '';
            break;
          case 'wellKnown':
            configFormTips.wellKnown = ssoConfig.wellKnown === '' ? i18n_t('不能为空') : '';
            break;
          default:
            break;
        }
      },
      throttleValidateConfigForm: _.throttle((type: string) => {
        const isDiff = ['tenantName', 'clientId', 'clientSecret', 'wellKnown'].some(
          key => ssoConfig[key] !== props.initData[key],
        );

        if (isDiff) {
          configFormTips.validate.code = 'none'; // 有改动清除测试结果
          configFormTips.validate.message = '';
        }
        methods.validateConfigForm(type);
      }, 500),
      handleConfigSuccess() {
        configFormTips.validate.code = 'success';
        configFormTips.validate.message = i18n_t('测试通过，点击完成进行登录验证');
      },
      async checkSSOConfig(updateMessage?: boolean) {
        try {
          const { data } = await smh.userAPI.checkIDaasConfig({
            type: 'sso',
            tenantName: ssoConfig.tenantName,
            clientId: ssoConfig.clientId,
            clientSecret: ssoConfig.clientSecret,
            wellKnown: ssoConfig.wellKnown,
          });
          Object.assign(configFormTips, data);
          methods.handleConfigSuccess();
          !updateMessage && tips.success(i18n_t('测试成功'));
        } catch (error) {
          configFormTips.validate.code = 'error';
          configFormTips.validate.message = i18n_t('配置失败，{slot1}', {
            slot1: formatError(error as MsgError),
          });
          tips.error(error as MsgError);
        }
      },
      async goToNextStep() {
        await methods.checkSSOConfig(true);
        if (configFormTips.validate.code === 'success') {
          currentStep.value = 1;
        }
      },
      goToPreviousStep() {
        currentStep.value = 0;
      },
      copyText(url: string) {
        copyText2Clipboard(url)
          .then(() => {
            tips.success(i18n_t('复制成功'));
          })
          .catch(() => {
            tips.success(i18n_t('复制失败'));
          });
      },
      confirmEditTenant() {
        const dialog = CustomDialog.confirm({
          header: i18n_t('是否编辑租户ID？'),
          body: i18n_t('你已经绑定了该租户ID的其他功能，如果重新编辑已关联的功能将会失效。'),
          theme: 'info',
          onConfirm: () => {
            showTenantText.value = false;
            if (dialog.hide) {
              dialog.hide();
            }
          },
        });
      },
      async finishConfig() {
        try {
          await smh.userAPI.updateIDaasConfig({
            type: 'sso',
            tenantName: ssoConfig.tenantName,
            clientId: ssoConfig.clientId,
            clientSecret: ssoConfig.clientSecret,
            wellKnown: ssoConfig.wellKnown,
          });
          context.emit('onSubmit', {
            ...ssoConfig,
          });
          innerShow.value = false;
        } catch (error) {
          tips.error(error as MsgError);
        }
      },
      onClose() {
        innerShow.value = false;
      },
      openCofileGuide() {
        dispatchRouter(httpUrl.staticCDNURLMap.userManualUrl);
      },
      // 确认清除配置
      removeConfirm() {
        methods.onClose();
        context.emit('refresh', 'idass-auth');
      },
    };
    watch(innerShow, () => {
      if (innerShow.value) {
        methods.init();
      }
    });
    return {
      innerShow,
      showModifyPage,
      showTenantText,
      ssoConfig,
      configFormTips,
      currentStep,
      disableNextBtn,
      ...methods,
    };
  },
});
